import React from 'react'
import './experience.css'

const Experience = () => {
  const experiences = [
    {
      position: 'Software Development Engineer',
      company: 'CarWale',
      period: 'Sep 2024 – Present',
      location: 'Mumbai, India',
      achievements: [
        <>Led the redesign of the vehicle listing and filtering experience across <strong>CarWale and BikeWale (1.1M+ combined MAU)</strong>, shipping new features alongside rendering and state-management optimizations that improved <strong>vehicle detail page CTR by 18%</strong>, <strong>cars explored per session by 27%</strong>, and <strong>reduced listing page bounce rate by 14%</strong>.</>,
        <>Redesigned the mobile push notification pipeline by <strong>migrating to Notifee</strong> and introducing a new data-driven notification flow; defined payload requirements with the notification platform team, improving delivery reliability and <strong>increasing notification CTR from 7–9% to 20–24%</strong>.</>,
        <>Led the <strong>React Native upgrade from v0.77 to v0.83</strong> and investigated production-only stability issues after rollout, identifying and fixing critical crashes across subsequent releases to <strong>improve crash-free users from 94% to 99.8%</strong>.</>,
        <>Built an <strong>offline-resilient analytics delivery mechanism</strong> that persisted failed tracking events locally and retried them in batches when connectivity was restored, <strong>preventing loss of business-critical analytics events</strong>.</>,
        <>Recognized as <strong>Developer of the Month (April 2026)</strong> for exceptional engineering contributions and ownership.</>
      ]
    }
  ]

  return (
    <section id="experience" className='card-container'>
      <h5>My Career Journey</h5>
      <h2>Experience</h2>

      <div className="container experience__container">
        <div className="experience__timeline">
          {experiences.map((exp, index) => (
            <div key={index} className="experience__item">
              <div className="experience__marker"></div>
              
              <div className="experience__content">
                <div className="experience__header">
                  <div className="experience__title-section">
                    <h3>{exp.position}</h3>
                    <p className="experience__company">{exp.company}</p>
                  </div>
                  <div className="experience__meta">
                    <span className="experience__period">{exp.period}</span>
                    <span className="experience__location">{exp.location}</span>
                  </div>
                </div>

                <ul className="experience__achievements">
                  {exp.achievements.map((achievement, idx) => (
                    <li key={idx}>{achievement}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
        <p className="experience__scroll-hint" aria-hidden="true">Swipe to explore experience <span>→</span></p>
    </section>
  )
}

export default Experience